import { Link } from "react-router-dom";
import WebLayout from "../layout/WebLayout";

function Legal() {
  return (
    <WebLayout pageName={Legal}>
      <div className="product-dContent__box">
        <div className="tab-content" id="pills-tabContent">
          <div
            className="tab-pane fade show active"
            id="pills-description"
            role="tabpanel"
            aria-labelledby="pills-description-tab"
            tabIndex="0">
            <div className="text-center">
              <h4 className="text-2xl mb-2">Welcome to Ardh Sainik Legal</h4>
              <h5 className="text-xl">
                <Link
                  to="https://ardhsainiklegal.com/"
                  target="_blank"
                  style={{ color: "#4072f1" }}>
                  www.ArdhSainikLegal.com
                </Link>
              </h5>
            </div>
            <hr></hr>
            <div className="mb-20">
              <p className="mb-2">
                Ardh Sainik Legal Associates (ASLA) is founded under the aegis
                of Ardh Sainik Welfare Trust (Regd.) The ASLA aims to support
                the entire soldiers’ community. Since there is an urgent need to
                facilitate the Soldiers, those get involved in litigation due to
                unknown reasons during the service time.
              </p>

              <p className="mb-10">
                The founder Team of the ASLA is keen to support them on a need
                basis through a single-window at PAN India basis. The ASLA
                brought its support and services to the table with a team of
                committed and dedicated professional Advocates and Lawyers at
                PAN India, who are specialists in their respective fields of
                practice of Law and dedicated to Soldiers and their families in
                legal matters.
              </p>
            </div>
          </div>
        </div>
      </div>
    </WebLayout>
  );
}

export default Legal;
